import React, { useState, useEffect } from 'react'
import moment from "moment";
import "moment-timezone";


import {
  Switch,
  Route,
  Redirect,
  useLocation
} from 'react-router-dom'
import { useWindowSize } from './hooks/useWindowSize'
import { useOnlineStatus } from './hooks/useOnlineStatus'
import { useSyncCouponWithCart } from './hooks/useSyncCouponWithCart'
import { useTranslation } from "react-i18next";
import { useTheme } from './contexts/ThemeContext';
import { useOrder } from './contexts/OrderContext'
import { useCart } from './contexts/CartContext'
import { AppWrap } from './components/Layout/AppWrap'
import { HelmetTags } from './components/HelmetTags'
import { RightMain } from './components/RightMain'
import { Home } from './pages/Home'
import { Order } from './pages/Order'
import { Contact } from './pages/Contact'
import { Delivery } from './pages/Delivery'
import { Payment } from './pages/Payment'
import { Confirm } from './pages/Confirm'
import { Failure } from './pages/Failure'
import { Transaction } from './pages/Transaction'
import { Pay } from './pages/Pay'
import { Loading } from './components/Shared/Loading'
import { VendorSwitchAlert } from './components/Shared/VendorSwitchAlert'
import 'bootstrap/dist/css/bootstrap.min.css';

export const App = () => {
  const onlineStatus = useOnlineStatus()
  const [, i18n] = useTranslation()
  const [orderDetail, { updateOrder }] = useOrder();
  const [isProductSearched, setIsProductSearched] = useState()
  const currentHour = moment().tz("Asia/Kuwait").hour();
  const [cart] = useCart();
  useSyncCouponWithCart()
  const location = useLocation();
  const { width } = useWindowSize();
  const [loaded, setLoaded] = useState(() => {
    const path = typeof window !== 'undefined' ? window.location.pathname : ''
    return path.startsWith('/pay') || path.startsWith('/transaction')
  })
  const [theme, { update }] = useTheme()

  const convertAmPm = (hour) => {
    return hour <= 11 ? hour + 'am' :
      hour === 12 ? hour + 'pm' : (hour - 12) + 'pm'
  }

  const searchProducts = (status) => {
    setIsProductSearched(status)
  }

  const isToday = (date) => {
    const today = new Date(moment().tz("Asia/Kuwait").format('YYYY/MM/DD'));

    if (
      today.getFullYear() === date.getFullYear() &&
      today.getMonth() === date.getMonth() &&
      today.getDate() === date.getDate()
    ) {
      return true;
    }
    return false;
  }

  const updateDeliveryTime = (orderDetail) => {
   // debugger
  
    if(!orderDetail.timeRange.length) {
      localStorage.removeItem('setupTime');
      return
    }
    const maxTime = orderDetail.timeRange[orderDetail.timeRange.length - 1];
    const minTime = orderDetail.timeRange[0];
     
    //const currentdate = new Date(moment().tz("Asia/Kuwait").format('YYYY/MM/DD'));
    //debugger
    var hours = 24; 
    var now = new Date().getTime();
    var setupTime = localStorage.getItem('setupTime');

    const isEnabledASAP = currentHour >= minTime && currentHour <= maxTime;
    const minDate = currentHour <= maxTime? moment().tz("Asia/Kuwait").format('YYYY/MM/DD'):
          moment().add(1, 'day').tz("Asia/Kuwait").format('YYYY/MM/DD');
    // if((currentHour + 1) < maxTime){
    //   debugger
    // }
    const savedDeliveryMoment = moment(`${orderDetail?.deiveryTime.date}:${orderDetail?.deiveryTime.time}`, "YYYY/MM/DD:ha").tz("Asia/Kuwait")
    const minDeliveryMoment = moment(`${orderDetail?.minDate}:${orderDetail?.isEnabledASAP ? convertAmPm(currentHour + 1) : convertAmPm(orderDetail?.minTime + 1)}`, "YYYY/MM/DD:ha").tz("Asia/Kuwait");

    if (savedDeliveryMoment.diff(minDeliveryMoment, 'hours') < 0) {
      updateOrder({
        deiveryTime: {
          date: orderDetail?.minDate,
          time: orderDetail?.isEnabledASAP ? convertAmPm(currentHour + 1) : convertAmPm(orderDetail?.minTime + 1)
        }
      })
    } 

    if(minDate > orderDetail?.deiveryTime.date) {
      updateOrder({
        minDate: minDate,
        deiveryTime: {
          date: minDate,
          time: isEnabledASAP ? convertAmPm(currentHour + 1) : convertAmPm(minTime + 1)
        }
      })
    }

    if (setupTime == null) {
      localStorage.setItem('setupTime', now)
    } else {
        if(now-setupTime > hours*60*60*1000) {
            localStorage.clear()
            //localStorage.setItem('setupTime', now);
        }
    }
  }

  useEffect(() => {
    // Pay-link / transaction pages don't need cart/order bootstrap — show immediately
    const isPayLink =
      location.pathname.startsWith('/pay') ||
      location.pathname.startsWith('/transaction')
    if (isPayLink) {
      setLoaded(true)
      return
    }
    if (orderDetail !== undefined && onlineStatus) {
      updateDeliveryTime(orderDetail)
      setLoaded(true)
    }
  }, [orderDetail, cart, onlineStatus, location.pathname])

  useEffect(() => {
    const currentLng = localStorage.getItem('i18nextLng') || 'ar';
    if (currentLng === 'ar') {
      i18n.changeLanguage("ar")
      document.body.dir = 'rtl';
    } else {
      i18n.changeLanguage("en")
      document.body.dir = 'ltr';
    }
    const currentDir = localStorage.getItem('i18nextLng') === 'ar' ? true : false;
    currentDir !== theme.rtl && update({ ...theme, rtl: !theme.rtl });
  }, [i18n, theme, update])

  return (
    <>
      {!loaded && <Loading />}
      {loaded &&
        <AppWrap>
          <HelmetTags />
          <VendorSwitchAlert />
          {onlineStatus && (
            <Switch>
              <Route exact path='/home'><Redirect to='/' /></Route>
              <Route exact path='/'><Home isProductSearched={isProductSearched} searchProducts={searchProducts} /></Route>
              <Route exact path='/order'>
                {
                  orderDetail.currentLocation
                    ? <Order />
                    : <Redirect to='/home' />
                }
              </Route>

              {/* Checkout customer info — /contact is a static store page (App/Play Store) */}
              <Route exact path='/customer'>
                {
                  orderDetail.currentLocation && cart.length > 0
                    ? <Contact />
                    : <Redirect to='/home' />
                }
              </Route>

              <Route exact path='/delivery'>
                {
                  orderDetail.currentLocation && orderDetail.contact && cart.length > 0
                    ? <Delivery />
                    : <Redirect to='/home' />
                }
              </Route>
              <Route exact path='/payment'>
                {
                  orderDetail.currentLocation && orderDetail.contact && orderDetail.address && cart.length > 0
                    ? <Payment />
                    : <Redirect to='/home' />
                }
              </Route>

              <Route exact path='/confirm'>
                {
                  <Confirm />
                }
              </Route>

              <Route exact path='/failure'>
                {
                  <Failure />
                }
              </Route>

              <Route exact path='/transaction'>
                <Transaction />
              </Route>
              <Route exact path='/transaction/:reference'>
                <Transaction />
              </Route>

              <Route exact path='/pay/:reference'>
                <Pay />
              </Route>

            </Switch>
          )}

          {(
            (location.pathname === '/' || location.pathname === '/home' || width > 990) &&
            // Hide side template on /pay/:reference only — not on /payment
            !(location.pathname === '/pay' || location.pathname.startsWith('/pay/')) &&
            !location.pathname.startsWith('/transaction')
          ) &&
            <RightMain
              searchIconShowed={location.pathname === '/' || location.pathname === '/home'}
              searchProducts={searchProducts}
              isProductSearched={isProductSearched} />
          }
        </AppWrap>
      }
    </>
  )
}